import * as actionTypes from '../Actions/ActionTypes'

const initialState = {
  list: [],
}

const getConversationsSuccess = (state, action) => {
  let { conversations } = action.payload

  return {
    ...state,
    list: conversations,
  }
}

const clearConversationsRedux = () => {
  return {
    ...initialState,
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CONVERSATIONS_SUCCESS:
      return getConversationsSuccess(state, action)
    case actionTypes.CLEAR_CONVERSATIONS_REDUX:
      return clearConversationsRedux()

    default:
      return state
  }
}

export default reducer
